import { Component, ReactNode } from 'react';
import { loadImage } from '../../../lib/utils/image';

enum ImgStatus {
  INITIAL,
  LOADING,
  LOADED,
  ERROR,
}

type IImgWithStatusRenderProp = (props: {
  src: string;
  status: ImgStatus;
}) => ReactNode;

interface IImgWithStatusProps {
  src: string;
  children: IImgWithStatusRenderProp;
}

interface IImgWithStatusState {
  status: ImgStatus;
  src?: string;
}

class ImgWithStatus extends Component<
  IImgWithStatusProps,
  IImgWithStatusState
> {
  private _isMounted: boolean;

  constructor(props) {
    super(props);

    this.state = {
      status: ImgStatus.INITIAL,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.src !== state.src) {
      return {
        status: props.src ? ImgStatus.INITIAL : ImgStatus.ERROR,
        src: props.src,
      };
    }

    return null;
  }

  componentDidMount() {
    this._isMounted = true;

    if (this.state.status === ImgStatus.INITIAL) {
      this.loadSrc();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.status === ImgStatus.INITIAL) {
      this.loadSrc();
    }
  }

  loadSrc() {
    this.setState({
      status: ImgStatus.LOADING,
    });

    loadImage(this.state.src).then(
      () => {
        if (this._isMounted) {
          this.setState({
            status: ImgStatus.LOADED,
          });
        }
      },
      () => {
        if (this._isMounted) {
          this.setState({
            status: ImgStatus.ERROR,
          });
        }
      },
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { src, children } = this.props;
    const { status } = this.state;

    return children({ src, status });
  }
}

export { ImgStatus };

export default ImgWithStatus;
